<template>
  <div class="container-fluid mt-2">
    <div class="col-lg-12 col-xs-12 videoPainel bg-white p-3 shadow_bar">
      <div class="center" :class="{ 'mt-5': !bigfive }">
        <div v-if="!bigfive && !custom_header">
          <h2 class="color-primary label-bold">ESTÁ PRONTO? VAMOS COMEÇAR?</h2>
          <h5 class="color-primary mt-4">
            PREPARE-SE PARA RESPONDER ALGUMAS PERGUNTAS COM UM BREVE
            <b>VÍDEO</b> SEU.
          </h5>

          <h5 class="color-primary mt-4">
            FALA SEU CADASTRO OU LOGIN E BOA SORTE!
          </h5>
          <h5 class="color-primary mt-4">
            ESPERAMOS TE VER EM BREVE NA PRÓXIMA ETAPA.
          </h5>
        </div>
        <div v-else>
          <slot></slot>
        </div>
      </div>
      <div class="row">
        <div
          class="p-5 col-xs-12"
          :class="onlySignin ? 'col-lg-12' : 'col-lg-6'"
        >
          <h4 class="color-primary mt-3 header_border">FAÇA <b>LOGIN</b></h4>
          <div class="row mt-4">
            <div class="col-lg-5 col-xs-12 bg-white mt-4">
              <button
                style="
                  background-color: #0076b5 !important;
                  border: 0px;
                  height: 40px;
                "
                class="btn btn-lg width100 btn-primary"
                @click="loginLinkedin(true)"
              >
                <i class="fab fa-linkedin"></i> LINKEDIN
              </button>
            </div>
            <div class="col-lg-1 center py-1 mt-4 center">OU</div>
            <div class="col-lg-6 bg-white pt-4">
              <input
                class="form-control width100 bg-input-candidate"
                style="
                  float: right;
                  height: 40px;
                  text-align: center;
                  border: none;
                "
                :class="{
                  'is-invalid': $v.login.email.$error,
                  'is-valid': !$v.login.email.$invalid,
                }"
                type="text"
                v-model="login.email"
                placeholder="EMAIL"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-xs-12 pt-3">
              <input
                class="form-control width100 bg-input-candidate"
                style="text-align: center; border: none; height: 40px"
                :class="{
                  'is-invalid': $v.login.password.$error,
                  'is-valid': !$v.login.password.$invalid,
                }"
                type="password"
                v-model="login.password"
                placeholder="Senha"
              />
            </div>
          </div>
          <div class="row pb-4 pt-3">
            <div class="col-lg-12 col-xs-12">
              <button
                type="button"
                :disabled="load_login"
                @click="loginCandidate"
                class="btn full width100 btn-degrade normal-degrade btn-login-candidate"
              >
                <div v-if="!load_login">ENTRAR</div>

                <div
                  v-show="load_login"
                  class="spinner-border text-light"
                  role="status"
                >
                  <span class="sr-only"></span>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 p-5 col-xs-12" v-if="!onlySignin">
          <h4 class="color-primary mt-3 header_border">
            CRIE SUA <b>CONTA</b>
          </h4>
          <div class="row mt-4">
            <div class="col-lg-5 col-xs-12 bg-white mt-4">
              <button
                style="
                  background-color: #0076b5 !important;
                  border: 0px;
                  height: 40px;
                "
                class="btn btn-lg width100 btn-primary"
                @click="loginLinkedin"
              >
                <i class="fab fa-linkedin"></i> LINKEDIN
              </button>
            </div>
            <div class="col-lg-1 center py-1 mt-4 center">OU</div>
            <div class="col-lg-6 bg-white pt-4">
              <input
                class="form-control width100 bg-input-candidate"
                style="
                  float: right;
                  height: 40px;
                  text-align: center;
                  border: none;
                "
                :class="{
                  'is-invalid': $v.user.name.$error,
                  'is-valid': !$v.user.name.$invalid,
                }"
                type="text"
                v-model="user.name"
                placeholder="NOME"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-xs-12 pt-3">
              <input
                class="form-control width100 bg-input-candidate"
                style="text-align: center; border: none; height: 40px"
                :class="{
                  'is-invalid': $v.user.email.$error,
                  'is-valid': !$v.user.email.$invalid,
                }"
                type="email"
                v-model="user.email"
                placeholder="EMAIL"
              />
            </div>
            <div class="col-lg-12 col-xs-12 pt-3">
              <input
                class="form-control width100 bg-input-candidate"
                style="text-align: center; border: none; height: 40px"
                :class="{
                  'is-invalid': $v.user.password.$error,
                  'is-valid': !$v.user.password.$invalid,
                }"
                type="password"
                v-model="user.password"
                placeholder="SENHA"
              />
            </div>
            <div class="col-lg-12 col-xs-12 pt-3">
              <input
                class="form-control width100 bg-input-candidate"
                style="text-align: center; border: none; height: 40px"
                :class="{
                  'is-invalid': $v.confirm_password.$error,
                  'is-valid': !$v.confirm_password.$invalid,
                }"
                type="password"
                v-model="confirm_password"
                placeholder="CONFIRME A SENHA"
              />
            </div>
          </div>
          <div class="row pb-4 pt-4">
            <div class="col-lg-6 col-xs-12">
              <label
                :class="{
                  seterror: !user.accept_terms && error_linkedin,
                }"
              >
                <input
                  v-model="user.accept_terms"
                  class="mt-2"
                  type="checkbox"
                />
                <span class="color-grey mt-1">ACEITOS OS</span>
                <a href="/termos_de_uso" target="_blank" style="color: blue"
                  >TERMOS DE USO</a
                >
              </label>
            </div>

            <div class="col-lg-6 col-xs-12">
              <button
                type="button"
                :disabled="load"
                @click="goToQuestion"
                class="btn full width100 normal-degrade btn-degrade btn-login-candidate"
              >
                <div v-if="!load">
                  <i class="fa fa-check"></i>
                  CADASTRAR
                </div>

                <div
                  v-show="load"
                  class="spinner-border text-light"
                  role="status"
                >
                  <span class="sr-only"></span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminCandidate from "layouts/AdminCandidate.vue";
import { required, email } from "vuelidate/lib/validators";
import { isMobile } from "mobile-device-detect";

export default {
  props: {
    account_uid: {
      type: String,
      default: "",
      required: false,
    },
    job: {
      type: Object,
      default: () => {},
      required: false,
    },
    job_link: {
      type: String,
      default: "",
      required: false,
    },
    candidate_uid: {
      type: String,
      default: "",
      required: false,
    },
    onlySignin: {
      type: Boolean,
      default: false,
      required: false,
    },
    bigfive: {
      type: Boolean,
      default: false,
      required: false,
    },
    selective_process_uid: {
      type: String,
      default: "",
      required: false,
    },
    bigfive_uid: {
      type: String,
      default: "",
      required: false,
    },
    custom_header: {
      type: Boolean,
      default: false,
    },
    avoid_tag: {
      type: Boolean,
      default: false,
    }
  },
  components: { AdminCandidate },
  data: () => ({
    user: {
      name: "",
      email: "",
      password: "",
      personal_site: "",
      personal_portfolio: "",
      accept_terms: false,
    },
    login: {
      email: "",
      password: "",
    },
    confirm_password: "",
    load: false,
    load_login: false,
    error_linkedin: false,
  }),
  mounted() {
    if (this.candidate_uid) {
      eventBus.$emit("candidateLogged");
    }
  },
  computed: {
    validForm() {
      if (this.$v.user.$invalid) return false;

      if (!this.user.accept_terms) return false;
      return true;
    },
    linkedinData() {
      let dataJob = {
        job_link: this.job_link,
        job_uid: this.job ? this.job.uid : null,
        account_uid: this.account_uid,
        process_uid: this.selective_process_uid,
      };

      let dataBigfive = {
        account_uid: this.account_uid,
        bigfive_uid: this.bigfive_uid,
      };

      return this.bigfive ? dataBigfive : dataJob;
    },
  },
  methods: {
    loginCandidate() {
      this.load_login = true;
      if (this.$v.login.$invalid) {
        this.$toast.error("PREENCHA OS DADS CORRETAMENTE PARA LOGAR");
        this.load_login = false;
        return false;
      }

      if (this.bigfive) {
        this.bigfiveSignin(this.login);
        return;
      }

      axios
        .post("/candidates/sessions", {
          candidates: {
            email: this.login.email,
            password: this.login.password,
          },
          account_uid: this.account_uid,
        })
        .then((response) => {
          if (response.data.status) {
            this.createApply({ email: this.login.email }, this.load_login);
            return;
          }
          this.load_login = false;
          this.$toast.error(
            "ERRO AO LOGAR NA APLICAÇÃO, CONFIRA SEU EMAIL E SENHA"
          );
        })
        .catch((error) => {
          this.load_login = false;
          this.$toast.error("ERRO AO LOGAR NA APLICAÇÃO");
        });
    },
    
    createApply(user, load) {
      axios
        .post("/candidates/apply", {
          candidates: user,
          jobs: {
            uid: this.job.uid,
            account_uid: this.account_uid ? this.account_uid : false,
          },
          avoid_tag: this.avoid_tag,
        })
        .then((response) => {
          if (response.data.status == false) {
            this.$toast.error(
              "ERRO: CANDIDATO JÁ EXISTE OU FORMULÁRIO FOI PREENCHIDO DE FORMA ERRADO "
            );
            load = false;
            return;
          }

          eventBus.$emit("goToQuestions", response.data.candidate);
        })
        .catch((error) => {
          this.$toast.error("ERRO AO APLICAR A ESSA VAGA");
        });
    },
    loginLinkedin(ignore_terms = false) {
      if (!this.user.accept_terms && !ignore_terms) {
        this.error_linkedin = true;
        this.$toast.error("ANTES DE CONTINUAR, ACEITE OS TERMOS DE USO");
        return;
      }
      this.error_linkedin = false;
      axios
        .post("/candidates/sessions/linkedin", this.linkedinData)
        .then((response) => {
          window.location = "/recruiters/auth/linkedin";
        })
        .catch((error) => {
          this.$toast.error("ERRO AO APLICAR A ESSA VAGA");
        });
    },
    bigfiveSignin(candidates) {
      let candidate = {
        name: candidates.name,
        email: candidates.email,
        password: candidates.password,
        bigfive_uid: this.bigfive_uid,
      };
      let url = !candidate.name ? "/bigfive/sign_in" : "/bigfive/sign_up";

      axios
        .post(url + `/${this.account_uid}`, { candidate })
        .then((response) => {
          this.load = false;
          this.load_login = false;

          if (response.status == 200) {
            eventBus.$emit("candidateLogged", response.data.candidate_uid);
          }
        })
        .catch((err) => {
          this.load = false;
          this.load_login = false;
          let response_status = err.response.status;

          if (response_status == 404 && !candidate.name) {
            this.$toast.error(
              "Não foi encontrado nenhum usuario com este e-mail"
            );
            return;
          }

          if (response_status == 404) {
            this.$toast.error(
              "Não foi possivel continuar a operação, tente novamente mais tarde."
            );
            return;
          }

          if (response_status == 403) {
            this.$toast.error(
              "Este é um teste privado, você não tem permissão para realiza-lo."
            );
            return;
          }

          if (response_status == 401) {
            this.$toast.error("Email ou senha inválidos.");
          }
        });
    },
    goToQuestion() {
      if (!this.validForm) {
        this.$toast.error(
          "PREENCHA OS DADOS CORRETAMENTE E ACEITE OS TERMOS DE USO PARA CONTINUAR"
        );
        return;
      }
      this.load = true;

      if (this.bigfive) {
        this.bigfiveSignin(this.user);
        return;
      }

      axios
        .post("/candidates/apply", {
          candidates: this.user,
          jobs: {
            uid: this.job.uid,
            account_uid: this.account_uid ? this.account_uid : false,
          },
        })
        .then(async (response) => {
          this.load = false;
          eventBus.$emit("goToQuestions", response.data.candidate);
        })
        .catch((error) => {
          this.load = false;
          this.load_login = false;
          if (error.response.tag_error) {
            this.$emit('tag_error', error.response.tag_error);
            return;
          }
          this.$toast.error("ERRO AO APLICAR A ESSA VAGA");
        });
    },
  },
  validations: {
    user: {
      email: { required, email },
      name: { required },
      password: { required },
    },
    login: {
      email: { required, email },
      password: { required },
    },
    confirm_password: { required },
  },
};
</script>